<template>
  <div>
    <CropperHeader :is-read-only="isReadOnly" type="translations" :field="currentField" :current="currentFieldIndex + 1" :total="fields.length" @help="$emit('help')" @back="previousField" @next="nextField" />
    <div class="pa-4 pb-12 lightgrey">
      <div v-if="!isReadOnly" id="translate-field-step-2">
        <div class="text-title">
          ENTER THE ENGLISH TRANSLATION
        </div>
        <TranslateInput v-if="currentField" :field="currentField" @input="$emit('updateField', { id: currentField.id, ...$event })" />
      </div>
      <div v-else>
        <div class="text-title">
          Your Translation
        </div>
        <div>
          {{ currentField.translatedValue || 'N/A' }}
        </div>
        <div class="text-title mt-8">
          Edits
        </div>
        <div>
          {{ currentField.notApplicable ? 'N/A' : (currentField.correctedValue || '--') }}
        </div>
      </div>
      <div id="translate-field-step-1">
        <div class="text-title mt-8">
          SOURCE
        </div>
        <div style="border: 1px solid #0000001F; min-height: 60px" class="d-flex align-center justify-center">
          <ImageView :markup-id="currentField.id" :is-purged="!!currentField.isDocumentPurged" :path="currentField.path" :can-update="!isReadOnly" block />
        </div>
        <div v-if="currentField.path && !isReadOnly" class="d-flex justify-space-between">
          <v-btn text color="tertiary" class="px-0" style="min-width: 20px" @click="$emit('deleteField', currentField)">
            Delete
          </v-btn>
          <v-btn text color="tertiary" class="px-0" style="min-width: 20px" :to="`./translate?step=select&markupId=${currentField.id}`">
            Edit
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CropperHeader from '../CropperHeader/CropperHeader.vue'
import ImageView from '@/domains/global/components/ImageView.vue'
import TranslateInput from './TranslateInput.vue'

export default {
  components: {
    CropperHeader,
    ImageView,
    TranslateInput
  },
  props: {
    fields: { type: Array, required: true },
    isReadOnly: { type: Boolean, default: false }
  },
  data() {
    return {
      currentFieldIndex: 0
    }
  },
  computed: {
    currentField() {
      return this.fields[this.currentFieldIndex]
    }
  },
  methods: {
    nextField() {
      const index = this.currentFieldIndex + 1
      if (index < this.fields.length) {
        this.currentFieldIndex = index
      }
    },
    previousField() {
      const index = this.currentFieldIndex - 1
      if (index > -1) {
        this.currentFieldIndex = index
      }
    }
  }
}
</script>
